export function formatTokens(n: number): string {
  if (n < 1000) return n.toLocaleString("pt-BR");
  if (n < 1_000_000) return `${(n / 1000).toFixed(n < 10_000 ? 1 : 0)}k`;
  return `${(n / 1_000_000).toFixed(n < 10_000_000 ? 2 : 1)}M`;
}

export function formatUsd(n: number): string {
  if (n === 0) return "$0.00";
  if (n < 0.01) return "<$0.01";
  if (n < 1) return `$${n.toFixed(3)}`;
  return `$${n.toFixed(2)}`;
}

export function formatMinutes(seconds: number): string {
  if (seconds <= 0) return "0min";
  const m = seconds / 60;
  if (m < 1) return `${Math.round(seconds)}s`;
  if (m < 60) return `${m.toFixed(m < 10 ? 1 : 0)}min`;
  const h = m / 60;
  return `${h.toFixed(h < 10 ? 1 : 0)}h`;
}
